module.exports = __webpack_public_path__ + "img/9791130617404.214b9e54.jpg";